import { FormikProps } from "formik";
import CustomInput from "../../../components/common/Inputs/CustomInput";
import Checkbox from "../../../components/common/Inputs/Checkbox";
import { ShippingCost } from "../../../interfaces/shippingCostType";

type ShippingCostFormProps = {
  formik: FormikProps<ShippingCost>;
};

export const ShippingCostForm = (props: ShippingCostFormProps) => {
  const { formik } = props;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <CustomInput
        label="Nombre de Envío"
        error={
          formik.touched.name &&
          formik.errors.name &&
          Array.isArray(formik.errors.name)
            ? formik.errors.name.join(", ")
            : formik.errors.name
        }
        {...formik.getFieldProps("name")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="Nombre del Proveedor"
        error={
          formik.touched.providerName &&
          formik.errors.providerName &&
          Array.isArray(formik.errors.providerName)
            ? formik.errors.providerName.join(", ")
            : formik.errors.providerName
        }
        {...formik.getFieldProps("providerName")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="URL de Rastreo"
        {...formik.getFieldProps("trackingURL")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="Orden"
        type="number"
        error={
          formik.touched.order &&
          formik.errors.order &&
          Array.isArray(formik.errors.order)
            ? formik.errors.order.join(", ")
            : formik.errors.order
        }
        {...formik.getFieldProps("order")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="Precio"
        type="number"
        error={
          formik.touched.price &&
          formik.errors.price &&
          Array.isArray(formik.errors.price)
            ? formik.errors.price.join(", ")
            : formik.errors.price
        }
        {...formik.getFieldProps("price")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="Costo"
        type="number"
        error={
          formik.touched.cost &&
          formik.errors.cost &&
          Array.isArray(formik.errors.cost)
            ? formik.errors.cost.join(", ")
            : formik.errors.cost
        }
        {...formik.getFieldProps("cost")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <Checkbox
        label="Costo de envío por defecto"
        id="defaultShipping"
        name="defaultShipping"
        onChange={() => {
          formik.setFieldValue("defaultShipping", !formik.values.defaultShipping);
        }}
        checked={formik.values.defaultShipping}
      />
    </div>
  );
};
